import React, { useState } from 'react';
import LeftArrow from '../assets/Left_arrow.svg';
import useIsMobile from '../hooks/useIsMobile';
import { useConsentActions } from '../hooks/useConsentActions';
import { formatFIType } from '../utils/fiGroups';
import './ConsentDetails.css';
import AuthApis from '../helper/api.service';
import Revoke from '../assets/Revoke.svg';

const FiuConsentDetails = (props) => {
    const isMobile = useIsMobile();
    const authApis = new AuthApis();
    const [state, setState] = useState({
        arrowHover: false,
    });
    const { revokeConsents } = useConsentActions(
        authApis,
        props.updateLoader,
        props.history
    );

    const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1).toLowerCase();

    const handleBack = () => {
        props.history.push({
            pathname: `/revoke-consent`,
            state: {
                selectedAccounts: props?.location?.state?.selectedAccounts,
                number: props?.location?.state?.number,
                fromConsentDetails: true, // Flag to indicate coming back from consent details
            },
        });
    };

    const dateFormat = (dateString, showTime) => {
        if (dateString) {
            let newDate = new Date(dateString);
            let dataArray = newDate.toString().split(' ');
            if (showTime) {
                return `${dataArray[2]} ${dataArray[1]} ${dataArray[3]} ${dataArray[4]}`;
            }
            return `${dataArray[2]} ${dataArray[1]} ${dataArray[3]}`;
        }
    };

    const handleRevoke = () => {
        revokeConsents(
            [props?.location?.state?.consent],
            props?.location?.state?.number,
        );
    };

    return (
        <section className="consent-details-page px-3 text-start" style={{ paddingTop: '100px', paddingBottom: '3rem' }}>
            <div className="mx-auto" style={{ maxWidth: '1200px' }}>
                <div className="d-flex align-items-center mb-3">
                    <span
                        onClick={handleBack}
                        onMouseEnter={() =>
                            setState((prev) => ({ ...prev, arrowHover: true }))
                        }
                        onMouseLeave={() =>
                            setState((prev) => ({ ...prev, arrowHover: false }))
                        }
                        className="d-inline-flex align-items-center justify-content-center rounded-circle"
                        style={{
                            width: '32px',
                            height: '32px',
                            background: state.arrowHover ? '#f0f0f0' : 'transparent',
                            transition: 'background 0.2s',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={LeftArrow}
                            alt="back"
                            style={{ height: '32px', width: '32px' }}
                        />
                    </span>
                    <h1 className="fw-semibold text-black m-0" style={{ fontSize: '16px', fontWeight: '600' }}>
                        Consent Details
                    </h1>
                </div>

                <p className="mb-4 text-start" style={{ color: '#6C6C6C', fontSize: '14px' }}>
                    You can revoke this consent given to {props?.location?.state?.consent?.consentDetails?.FIU?.name}
                </p>

                <div className={`d-flex ${isMobile ? 'flex-column' : 'flex-row'}`} style={{
                    gap: '16px', ...(!isMobile && {
                        maxHeight: '36rem',
                    }),
                }}>
                    {/* Left card - Consent Details */}
                    <div 
                        className="bg-white border rounded-3 p-4 px-3"
                        style={{
                            flex: isMobile ? '1' : '0 0 48%',
                            borderColor: '#E0E0E0',
                        }}
                    >
                        <h2 className="fw-semibold" style={{ color: '#111111', fontSize: '14px',marginBottom: '2px' }}>
                            Consent Purpose
                        </h2>
                        <p className="mb-4" style={{ color: '#666', lineHeight: '1.5', fontSize: '14px' }}>
                            {props?.location?.state?.consent?.consentDetails?.Purpose?.text}
                        </p>

                        {/* Two Column Grid for Details */}
                        <div className="row g-3">
                            <div className="col-6">
                                <p className="mb-1" style={{ color: '#6C6C6C', fontSize: '14px' }}>
                                    Consent given on
                                </p>
                                <p className="fw-medium" style={{ color: '#111111', fontSize: '14px' }}>
                                    {dateFormat(props?.location?.state?.consent?.consentDetails?.createTime, false)}
                                </p>
                            </div>

                            <div className="col-6">
                                <p className="mb-1" style={{ color: '#6C6C6C', fontSize: '14px' }}>
                                    Consent expires on
                                </p>
                                <p className="fw-medium" style={{ color: '#111111', fontSize: '14px' }}>
                                    {dateFormat(props?.location?.state?.consent?.consentDetails?.expireTime, false)}
                                </p>
                            </div>

                            <div className="col-6">
                                <p className="mb-1" style={{ color: '#6C6C6C', fontSize: '14px' }}>
                                    Account Types
                                </p>
                                <p className="fw-medium" style={{ color: '#111111', fontSize: '14px' }}>
                                    {props?.location?.state?.consent?.consentDetails?.fiTypes
                                        ? props.location.state.consent.consentDetails.fiTypes.map(formatFIType).join(', ')
                                        : ""}
                                </p>
                            </div>

                            <div className="col-6">
                                <p className="mb-1" style={{ color: '#6C6C6C', fontSize: '14px' }}>
                                    Data Stored For
                                </p>
                                <p className="fw-medium" style={{ color: '#111111', fontSize: '14px' }}>
                                    {props?.location?.state?.consent?.consentDetails?.DataLife
                                        ? `${props.location.state.consent.consentDetails.DataLife.value} ${props.location.state.consent.consentDetails.DataLife.unit}`
                                        : ''}
                                </p>
                            </div>

                            <div className="col-6">
                                <p className="mb-1" style={{ color: '#6C6C6C', fontSize: '14px' }}>
                                    Data Start Date
                                </p>
                                <p className="fw-medium" style={{ color: '#111111', fontSize: '14px' }}>
                                    {dateFormat(props?.location?.state?.consent?.consentDetails?.DataDateTimeRange?.from, false)}
                                </p>
                            </div>

                            <div className="col-6">
                                    <p className="mb-1" style={{ color: '#6C6C6C', fontSize: '14px' }}>
                                    Data End Date
                                </p>
                                <p className="fw-medium" style={{ color: '#111111', fontSize: '14px' }}>
                                    {dateFormat(props?.location?.state?.consent?.consentDetails?.DataDateTimeRange?.to, false)}
                                </p>
                            </div>

                            <div className="col-12">
                                <p className="mb-1" style={{ color: '#6C6C6C', fontSize: '14px' }}>
                                    Account Details
                                </p>
                                <p className="fw-medium" style={{ color: '#111111', fontSize: '14px' }}>
                                    {props?.location?.state?.consent?.consentDetails?.consentTypes
                                        ? props.location.state.consent.consentDetails.consentTypes
                                            .map((el) => capitalize(el).replace(/[-_]/g, ' '))
                                            .join(', ')
                                        : 'Profile, Summary, Transactions'}
                                </p>
                            </div>

                            <div className="col-6">
                                <p className="mb-1" style={{ color: '#6C6C6C', fontSize: '14px' }}>
                                    Purpose Code
                                </p>
                                <p className="fw-medium" style={{ color: '#111111', fontSize: '14px' }}>
                                    {props?.location?.state?.consent?.consentDetails?.Purpose?.code}
                                </p>
                            </div>
                        </div>

                        <div className="mt-4 pt-4 border-top" style={{ borderColor: '#E0E0E0', color: '#6C6C6C', fontSize: '14px' }}>
                            For any grievances you can reach out to us at grievances@cookiejar.co.in
                        </div>
                </div>

                {/* Right card - Accounts */}
                <div 
                    className="bg-white border rounded-3 p-4 px-3 d-flex flex-column"
                    style={{
                        flex: isMobile ? '1' : '0 0 48%',
                        borderColor: '#E0E0E0',
                    }}
                >
                    <div className="mb-4">
                        <h2 className="fw-semibold m-0" style={{ color: '#111111', fontSize: '14px',fontWeight: '600' }}>
                            Accounts
                        </h2>
                    </div>

                    {/* Scrollable Accounts List */}
                    <div className="mb-4" style={{ flex: 1, overflowY: 'auto' }}>
                        {props?.location?.state?.consent?.consentDetails?.Accounts?.map((account, i) => (
                            <div key={i} className="d-flex align-items-center mb-2 px-3 py-2" style={{ backgroundColor: '#F8F8F8', gap: '12px', fontSize: '14px', borderRadius: '8px' }}>
                                <div 
                                    className="bg-white rounded d-flex align-items-center justify-content-center"
                                    style={{ width: '24px', height: '24px' }}
                                >
                                    <img 
                                        src={account.fipLogoUri} 
                                        alt="bank"  
                                        style={{ width: '16px', height: '16px', objectFit: 'contain' }}
                                    />
                                </div>
                                <span className="fw-medium" style={{ color: '#111111',fontWeight: '500', fontSize: '12px', lineHeight:'14px' }}>
                                    {account?.fipName} • {account?.maskedAccNumber}
                                </span>
                            </div>
                        ))}
                    </div>

                    {/* Revoke Button */}
                    <button
                        onClick={handleRevoke}
                        className="w-100 btn text-white rounded-2 fw-semibold d-flex align-items-center justify-content-center"
                        style={{
                            backgroundColor: props.customDetails?.primaryColor || '#3E4DAC',
                            padding: '9.5px 14px',
                            gap: '8px',
                            transition: 'opacity 0.2s',
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.opacity = '0.9';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.opacity = '1';
                        }}
                    >
                        <img src={Revoke} alt="revoke" style={{ width: '20px', height: '20px' }} />
                        Revoke consent
                    </button>
                </div>
            </div>
            </div>
        </section>
    );
};

export default FiuConsentDetails;
